export default "__VITE_ASSET__5XtP4GQx__"